<template>
    <div class="page-wrapper order-page-wrapper">
        <div class="header-wrapper">
            <van-dropdown-menu >
                <van-dropdown-item @change="handleRecentlyMonthChange" v-model="recentlyMonth" :options="monthSelectList" />
            </van-dropdown-menu>
            <van-button @click="handleCalendarDailogShow('start')" type="default">{{ startDate ? startDate : '选择日期范围'}}</van-button>
            <van-button @click="handleCalendarDailogShow('end')" type="default">{{ endDate ? endDate : '选择日期范围'}}</van-button>
        </div>

        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div v-if="orderList.length > 0" class="order-item-list-wrapper">
                <order-item v-for="(item, index) in orderList" :key="index" :item="item"></order-item>
            </div>
            <van-empty v-else description="暂无订单" />
        </van-pull-refresh>

        <van-calendar 
            position="top" 
            :min-date="minDate"
            :max-date="maxDate"
            :title="calendarTitle"
            v-model="calendarShow" 
            color="#0098DD"
            @confirm="onCalendarSelectConfirm" 
            :poppable="true"/>
    </div>
</template>

<script>
import {dateFormat} from '@/utils/date';
import OrderItem from '../../components/order-item/index'
export default {
    components:{
        OrderItem,
    },
    created(){

    },
    mounted(){
        var _this = this;
        this.getOrders()

        // 滑动到底部时加载新订单，一次加载20条
        window.onscroll = function(){
            //变量scrollTop是滚动条滚动时，距离顶部的距离
            var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
            //滚动条到底部的条件
            if(scrollTop+windowHeight == scrollHeight){
                //到了这个就可以进行业务逻辑加载后台数据了
                _this.concatOrders();
            }
        }
    },
    computed:{
        calendarTitle(){
            return this.calendarSelectType === 'start' ? '订单最早日期' : '订单最晚日期'
        },
    },
    data() {
        return {
            startDate: '',
            endDate: '',
            minDate: new Date(new Date().getFullYear() - 10, 0, 31),  
            maxDate: new Date(new Date().getFullYear() + 10, 0, 31), 
            calendarSelectType: '',
            recentlyMonth: 0,
            calendarShow: false,
            isLoading: false,
            currentPage : 1 ,
            lastShow : false,
            orderList: [],
            monthSelectList: [
                { text: '所有时间', value: 0 },
                { text: '近一月', value: 1 },
                { text: '近三月', value: 3 },
            ]
        };
    },
    methods:{
        onCalendarSelectConfirm(date){
            const selectedDate = dateFormat("yyyy-MM-dd",new Date(date))
            this.calendarSelectType === 'start' ? this.startDate = selectedDate : this.endDate = selectedDate
            this.calendarShow = false
            this.initSearchParam()
            this.getOrders()
        },
        handleCalendarDailogShow(type){
            this.calendarSelectType = type
            this.calendarShow = true
        },
        handleRecentlyMonthChange(value){
            this.startDate = ''
            this.endDate = ''
            this.initSearchParam()
            this.getOrders()
        },
        onRefresh(){
            this.initSearchParam()
            this.getOrders()
        },
        initSearchParam : function(){
            // 恢复参数
            this.currentPage = 1;
            this.lastShow = false;
            this.orderList = [];
        },
        getOrders(){
            const _this = this
            _this.isLoading = true
            _this.$get('/folder/getFoldersByStatus/' + 'all' + '/' + '1' + '/' + '10',{
                startTime: _this.startDate,
                endTime: _this.endDate,
                lessMonth: _this.recentlyMonth === 0 ? '' : 'M' + _this.recentlyMonth
            }).then(res => {
                if(res.data.data){
                    _this.orderList = res.data.data.records
                }
            }).finally(()=>{
                _this.isLoading = false
            })
        },
        concatOrders(){
            const _this = this
            if(_this.lastShow){ // 已经加载完了
                return
            }else {
                _this.currentPage++;
            }
            _this.isLoading = true
            _this.$get('/folder/getFoldersByStatus/' + 'all' + '/' + _this.currentPage + '/' + '10',{
                startTime: _this.startDate,
                endTime: _this.endDate,
                lessMonth: _this.recentlyMonth === 0 ? '' : 'M' + _this.recentlyMonth
            }).then(res => {
                if(res.data.data){
                    if(res.data.data.current >= res.data.data.pages){
                        _this.lastShow = true
                    }
                    _this.orderList = _this.orderList.concat(res.data.data.records);
                }
            }).finally(()=>{
                _this.isLoading = false
            })
        },
    }
}
</script>

<style lang="scss">
.header-wrapper{
    display: flex;
    flex-direction: row;

    .van-dropdown-menu{
        flex: 1;
    }

    .van-dropdown-menu__bar::before{
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        border-bottom: 1px solid #000 ;
    }
    
    .van-dropdown-menu__bar{
        box-shadow: none;
    }

    .van-button{
        flex: 1;
        height: 48px;
        border-left: none;
        border-right: none;
    }

}

.van-pull-refresh{
    /*导致了页面没有滑动条，显示不全*/
    /*height: calc(100vh - 48px);*/
}
</style>